<template>
  <transition name="confirm-fade">
    <div v-if="showBool" class="my-popup">
      <div class="confirm-content-wrap">
        <div>
          <img src="static/images/default524.jpg" alt="">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default{
    name:'popup',
    props:['showBool'],
    data(){
      return {
      }
    },
    created(){},
    mounted(){},
    methods:{},
    watch:{
      'showBool':function (a,b) {
        if(a){
          let that=this;
          setTimeout(function () {
            that.$emit('toggle',false)
          },1500)
        }
      }
    }
  }
</script>

<style scoped>
  .my-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  .confirm-fade-enter-active .confirm-content-wrap {
    animation: scale 0.3s;
  }
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }

  /* 包裹层容器样式 */
  .confirm-content-wrap {
    position: absolute;
    top: 28%;
    left: 0;
    right: 0;
    width: 280px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 5px;
    z-index: 999;
    user-select: none;
  }
  .confirm-content-wrap>div{
    padding: 0.5rem;
  }

  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes scale {
    0% {
      transform: scale(0);
    }
    60% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup.vue